import React from 'react';
import { createRoot } from 'react-dom/client';
import { FlagProvider, UnleashClient } from '@unleash/proxy-client-react';
import ViewportProvider from 'providers/Viewport';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'sanitize.css/sanitize.css';
import './theme/icomoon/style.css';
import './theme/custom-bootstrap.scss';
import './styles/globals.css';

const unleashConfig = {
  url: process.env.REACT_APP_UNLEASH_PROXY_URL,
  clientKey: process.env.REACT_APP_UNLEASH_SECRET_KEY,
  refreshInterval: process.env.REACT_APP_UNLEASH_REFRESH_INTERVAL,
  appName: process.env.REACT_APP_UNLEASH_APP_NAME,
  environment: process.env.REACT_APP_UNLEASH_ENVIRONMENT,
};

const unleashClient = new UnleashClient(unleashConfig);

const isLocalDev = window.location.hostname === 'localhost';

const startClient =
  !isLocalDev &&
  (process.env.NODE_ENV === 'production' ||
    process.env.REACT_APP_UNLEASH_START_CLIENT === 'true');

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ViewportProvider>
      <FlagProvider unleashClient={unleashClient} startClient={startClient}>
        <App />
      </FlagProvider>
    </ViewportProvider>
  </React.StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
